module.exports = __webpack_public_path__ + "assets/e1f3bfad2719dc64f51301477d2faad0.png";